var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4802_1249)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.16602,
    y: 2.5,
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6358 16.7198C32.7055 16.6501 32.7882 16.5948 32.8793 16.5571C32.9703 16.5194 33.0679 16.5 33.1664 16.5C33.265 16.5 33.3626 16.5194 33.4536 16.5571C33.5447 16.5948 33.6274 16.6501 33.6971 16.7198C33.7667 16.7894 33.822 16.8722 33.8597 16.9632C33.8974 17.0543 33.9169 17.1518 33.9169 17.2504C33.9169 17.3489 33.8974 17.4465 33.8597 17.5376C33.822 17.6286 33.7667 17.7113 33.6971 17.781L26.1971 25.281C26.1274 25.3507 26.0447 25.4061 25.9536 25.4438C25.8626 25.4815 25.765 25.501 25.6664 25.501C25.5679 25.501 25.4703 25.4815 25.3792 25.4438C25.2882 25.4061 25.2055 25.3507 25.1358 25.281L17.6358 17.781C17.4951 17.6403 17.416 17.4494 17.416 17.2504C17.416 17.0514 17.4951 16.8605 17.6358 16.7198C17.7765 16.579 17.9674 16.5 18.1664 16.5C18.3655 16.5 18.5563 16.579 18.6971 16.7198L25.6664 23.6901L32.6358 16.7198ZM25.6664 31.1901L18.6971 24.2198C18.5563 24.079 18.3655 24 18.1664 24C17.9674 24 17.7765 24.079 17.6358 24.2198C17.4951 24.3605 17.416 24.5514 17.416 24.7504C17.416 24.9494 17.4951 25.1403 17.6358 25.281L25.1358 32.781C25.2055 32.8507 25.2882 32.9061 25.3792 32.9438C25.4703 32.9815 25.5679 33.001 25.6664 33.001C25.765 33.001 25.8626 32.9815 25.9536 32.9438C26.0447 32.9061 26.1274 32.8507 26.1971 32.781L33.6971 25.281C33.7667 25.2113 33.822 25.1286 33.8597 25.0376C33.8974 24.9465 33.9169 24.8489 33.9169 24.7504C33.9169 24.6518 33.8974 24.5543 33.8597 24.4632C33.822 24.3722 33.7667 24.2894 33.6971 24.2198C33.6274 24.1501 33.5447 24.0948 33.4536 24.0571C33.3626 24.0194 33.265 24 33.1664 24C33.0679 24 32.9703 24.0194 32.8793 24.0571C32.7882 24.0948 32.7055 24.1501 32.6358 24.2198L25.6664 31.1901Z",
    fill: "#FBAE17"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4802_1249",
    x: 0.166016,
    y: 0.5,
    width: 51,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4802_1249"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4802_1249",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdded);
export default __webpack_public_path__ + "static/media/Added.13d15bcba5641ee025449c3098bb23ed.svg";
export { ForwardRef as ReactComponent };